import React from 'react'
import './RightPanel.css'

interface RightPanelProps {
  isOpen: boolean
  title: string
  onClose: () => void
  children?: React.ReactNode
}

export const RightPanel: React.FC<RightPanelProps> = ({ isOpen, title, onClose, children }) => {
  if (!isOpen) {
    return null
  }

  return (
    <aside className="rightPanel">
      <div className="rightPanel__header">
        <h2 className="rightPanel__title">{title}</h2>
        <button onClick={onClose} className="rightPanel__closeBtn" aria-label="Cerrar panel">
          ✕
        </button>
      </div>
      <div className="rightPanel__content">{children}</div>
    </aside>
  )
}
